module.exports = __webpack_public_path__ + "static/media/vet-nurse.dd792c01.jpg";